import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticatorService } from '@aws-amplify/ui-angular';

export const authGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const authenticator = inject(AuthenticatorService);

  if (authenticator.authStatus !== 'authenticated') {
    return router.createUrlTree(['login']);
  }
  return true;
};
